import React from "react";
import styles from "./sidebar.module.scss";
import { Link,useLocation } from "react-router-dom";

const SideBar = ({mobileView}) => {
  const router = useLocation()
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
      <Link to="/">
        {!mobileView&&<div className={styles.logo}><img src={"/assets/logo.svg"}/>HOGI PAY</div> }</Link>
        <div className={styles.heading}>MENU</div>
        <Link to="/wallet">
          <a className={`${router.pathname === "/wallet" ? styles.activeLink : styles.tab} `}>
            <div className={styles.icon}><img src={"/assets/wallet.svg"}/></div>
            <div className={styles.iconActive}>< img src={"/assets/wallet-active.svg"}/></div>
            <div className={styles.text}>WALLET</div>
          </a>
        </Link>
        <Link to="/exchange">
          <a className={`${router.pathname === "/exchange" ? styles.activeLink : styles.tab} `}>
            <div className={styles.icon}><img src={"/assets/exchange.svg"}/></div>
            <div className={styles.iconActive}>< img src={"/assets/exchange-active.svg"}/></div>
            <div className={styles.text}>EXCHANGE</div>
          </a>
        </Link>
        <Link to="/transaction">
          <a className={`${router.pathname === "/transaction" ? styles.activeLink : styles.tab} `}>
            <div className={styles.icon}><img src={"/assets/transaction.svg"}/></div>
            <div className={styles.iconActive}>< img src={"/assets/transaction-active.svg"}/></div>
            <div className={styles.text}>TRANSACTION</div>
          </a>
        </Link>
        <div className={styles.heading}>ACCOUNT</div>
        <Link to="/profile">
          <a className={`${router.pathname === "/profile" ? styles.activeLink : styles.tab} `}>
            <div className={styles.icon}><img src={"/assets/profile.svg"}/></div>
            <div className={styles.iconActive}>< img src={"/assets/profile-active.svg"}/></div>
            <div className={styles.text}>PROFILE</div>
          </a>
        </Link>
        <Link to="/settings">
          <a className={`${router.pathname === "/settings" ? styles.activeLink : styles.tab} `}>
            <div className={styles.icon}><img src={"/assets/settings.svg"}/></div>
            <div className={styles.iconActive}>< img src={"/assets/settings-active.svg"}/></div>
            <div className={styles.text}>SETTING</div>
          </a>
        </Link>
        <Link to="/support">
          <a className={`${router.pathname === "/support" ? styles.activeLink : styles.tab} `}>
            <div className={styles.icon}><img src={"/assets/support.svg"}/></div>
            <div className={styles.iconActive}>< img src={"/assets/support-active.svg"}/></div>
            <div className={styles.text}>SUPPORT</div>
          </a>
        </Link>
      </div>
      <Link to="/">
          <a className={`${router.pathname === "/1" ? styles.activeLink : styles.signout} `}>
            <div className={styles.icon}><img src={"/assets/wallet.svg"}/></div>
            <div className={styles.iconActive}>< img src={"/assets/wallet-active.svg"}/></div>
            <div className={styles.text}>SIGNOUT</div>
          </a>
        </Link>
    </div>
  );
};

export default SideBar;
